<template>
  <div class="body">
    <!-- <Menu title="FlowStudio" :menulist="menulist" @menu-click="handleMenuClick" :menuIndex="1"></Menu> -->
    <div class="center custom-scrollbar">
      <div class="title">新建项目空间</div>
      <div class="cenbody">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="项目名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="空间类型">
            <el-select v-model="form.space_type" placeholder="请选择" style="width: 100%;">
              <el-option v-for="(item,index) in configs.space_types" :key="index" :label="item.name" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目简介">
            <el-input type="textarea" v-model="form.info" placeholder="未来的科技世界，人工智能与人类共同探索宇宙奥秘的故事"></el-input>
          </el-form-item>
          <!-- <el-form-item label="">
            <div class="item2">请选择空间需要启用的AI接口（后期可在空间管理中更改）</div>
            <div class="module">
              <el-radio-group v-model="form.ai_model" size="medium">
              <el-radio border label="0">可灵3.0</el-radio>
              <el-radio border label="1">千问</el-radio>
              <el-radio border label="2">万象</el-radio>
              <el-radio border label="3">即梦</el-radio>

            </el-radio-group>
            </div>
          </el-form-item> -->
          <el-form-item label="">
            <div class="item2">请选择空间需要启用的功能模块（后期可在空间管理中更改）</div>
            <el-checkbox-group v-model="form.modules">
              <el-checkbox name="type" v-for="(item,index) in configs.modules" :key="index" :label="item.value" >{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="">
            <div class="item2 teamselect">成员选择 <div class="add" @click="dialogFormVisible=true">+ 添加成员</div></div>
            <div class="teamlist">
              <div class="item" v-for="(item,index) in form.team_users" :key="index" @click="form.team_users.splice(index, 1)">{{item.nickname}} ×</div>
            </div>
            <!-- <el-select v-model="form.team_users" multiple placeholder="请选择" style="width: 100%;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="">
            <div class="item2">协同方式</div>
            <el-radio-group v-model="form.work_type">
              <el-radio name="type" v-for="(item,index) in configs.work_types" :key="index" :label="item.value">{{item.name}}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="">
            <div class="item2">权限设置</div>
            <el-radio-group v-model="form.permission_type" size="medium">
              <el-radio v-for="(item,index) in configs.permission_types" :key="index" :label="item.value" >{{item.name}}</el-radio>

            </el-radio-group>
          </el-form-item>

          <el-form-item style="margin-top: 20px;">
            <el-button>取消</el-button>
            <el-button type="primary" @click="onSubmit" class="next" style="margin-left: 600px;">下一步</el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-dialog title="添加项目成员" :visible.sync="dialogFormVisible">
        <input class="seaipt" type="text" v-model="sea" placeholder="请输入用户名，回车搜索" @keyup.enter="serUers">
        <div class="userlist" v-if="seaList.length!==0">
          <div class="item" v-for="(item,index) in seaList" :key="index">
            <div class="l">{{item.nickname}}</div>
            <div class="r" @click="add(item)">+</div>
          </div>
        </div>
          <el-empty v-else description="暂无用户"></el-empty>
    </el-form-item>
  </el-form>
  <!-- <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
  </div> -->
</el-dialog>
    </div>
  </div>
</template>

<script>
// import Menu from '@/components/Menu2.vue'
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: '',
  // components: {
  //   Menu // 注册组件
  // },
  data () {
    return {
      menuIndex: 1,
      menulist: [
        {
          img1: require('@/assets/images/menu1.png'),
          img2: require('@/assets/images/menu1-2.png'),
          text: 'ai对话'
        },
        {
          img1: require('@/assets/images/menu2.png'),
          img2: require('@/assets/images/menu2-2.png'),
          text: '协作空间'
        },
        {
          img1: require('@/assets/images/menu3.png'),
          img2: require('@/assets/images/menu3-2.png'),
          text: '教学空间'
        },
        {
          img1: require('@/assets/images/menu4.png'),
          img2: require('@/assets/images/menu4-2.png'),
          text: '思维导图'
        },
        {
          img1: require('@/assets/images/menu5.png'),
          img2: require('@/assets/images/menu5-2.png'),
          text: 'PPT生成'
        },
        {
          img1: require('@/assets/images/menu6.png'),
          img2: require('@/assets/images/menu6-2.png'),
          text: '音频创作'
        },
        {
          img1: require('@/assets/images/menu7.png'),
          img2: require('@/assets/images/menu7-2.png'),
          text: '我的知识库'
        },
        {
          img1: require('@/assets/images/menu8.png'),
          img2: require('@/assets/images/menu8-2.png'),
          text: '插件工具市场'
        }
      ],
      configs: {},
      options: [
        {
          value: '0',
          label: '杨杨杨'
        }, {
          value: '1',
          label: '王王'
        },
        {
          value: '2',
          label: '张张'
        },
        {
          value: '3',
          label: '钱钱'
        },
        {
          value: '4',
          label: '孙孙'
        },
        {
          value: '5',
          label: '丽丽'
        }],
      dialogFormVisible: false,
      space_type: [
        {
          value: '0',
          label: '项目制作'
        }, {
          value: '1',
          label: '创意制作'
        }],
      form: {
        name: '',
        space_type: '',
        ai_model: '0',
        info: '',
        modules: [],
        team_users: [],
        work_type: '',
        permission_type: ''

      },
      seaList: [],
      sea: ''
    }
  },
  async created () {
    const res = await this.$http('api.getProjectConfig')
    this.configs = res.data
  },
  mounted () {

  },
  methods: {
    add (val) {
      let isadd = true
      for (let i = 0; i < this.form.team_users.length; i++) {
        if (this.form.team_users[i].id == val.id) {
          isadd = false
          break
        }
      }
      if (isadd) {
        console.log(val, 'val')

        this.form.team_users.push(val)
      }
    },
    async serUers () {
      console.log(this.sea, 'lll')
      const res = await this.$http('api.getUserlist', {
        keyword: this.sea, // 选填，搜索关键词
        page: 1, // 选填，页码
        limit: 100 // 选填，每页数量
        // "exclude_current": 1 // 选填，是否排除当前用户
      })
      console.log(res)
      this.seaList = res.data.list
    },
    arrtostr (arr) {
      let str = ''
      arr.forEach((item, index) => {
        if (index !== arr.length - 1) {
          str += item + ','
        } else {
          str += item
        }
      })
      return str
    },
    changeIndex (val) {
      this.menuIndex = val
    },
    async onSubmit () {
      const form = JSON.parse(JSON.stringify(this.form))
      form.modules = this.arrtostr(form.modules)
      const ls = []
      form.team_users.forEach(item => {
        ls.push(item.id)
      })
      form.team_users = this.arrtostr(ls)
      const res = await this.$http('api.createSpace', form)
      console.log(res, 'ress')
      this.$message.success('创建成功')
      setTimeout(() => {
        this.$router.replace(`/project2/project2_1?id=${res.data.project_id}`)
        // location.href('')
      }, 500)
    },
    handleMenuClick () {

    }
  }
}
</script>
<style lang="scss" scoped>
.body {
  display: flex;
}

.center {
  flex: 1;
  background-color: #fff;
  padding: 24px;
  margin-left: 16px;
  overflow: auto;

  .title {
    font-size: 24px;
    color: #262626;
    font-weight: 600;

  }

  .cenbody {
    margin-top: 10px;
    width: 800px;
    // height: 100%;
    // overflow: auto;
    padding-bottom: 20px;

    .item2 {
      padding-left: 10px;
      position: relative;
      width: 100%;
    }

    .item2::after {
      position: absolute;
      width: 4px;
      height: 16px;
      background-color: #046DFA;
      content: '';
      display: block;
      left: 0;
      top: 12px;
    }
  }
  .seaipt{
    width: 100%;
    height: 40px;
    border: 1px solid #b9b7b7;
    padding: 0 10px;
    border-radius: 8px;
  }
  .seaipt:hover{
    border: 1px solid #3879ce;
  }
  .userlist{
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    .item{
      padding: 0 20px;
      margin-top: 20px;
      border: 1px solid #4f7ddf;
      margin-left: 7%;
      height: 40px;
      line-height: 40px;
      width: 40%;
      border-radius: 8px;
      display: flex;
      justify-content: space-between;
      .l{

      }
      .r{
        margin-top: -2px;
        cursor: pointer;
        font-size: 30px;
        color: #4f7ddf;
      }
    }
  }
}
</style>
